import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface PatientCatheterParameter  extends Parameter {

    searchTerm: number;
    orderBy: string;

}


export interface PatientCatheter {

    id?: any;
    bedSore: any;   
    catheterUsage: any;   
    catheterType:any;
    cathetersize:any;
    levelofInjury:any;
    percentageofDisability:any;
    urineBag:any;

    tenantId: any;
    branchId: any;
    regId: string;  
    
    parameters?: PatientCatheterParameter[];
    links?: any;

}
export abstract class PatientCatheterData { 

    abstract list(url: string): Observable<PatientCatheter[]>;
    abstract create(url: string, data: PatientCatheter): Observable<any>;
    abstract update(url: string, data: PatientCatheter): Observable<any>;
    abstract delete(url: string): Observable<any>; 
   
}
